import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FiCheckCircle, FiXCircle, FiLoader } from 'react-icons/fi';
import axios from '../utils/axios';

const VerifyEmail = () => {
  const { verificationtoken } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    verifyEmail();
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`/auth/verifyemail/${verificationtoken}`);
      setStatus('success');
      setMessage(response.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.message || 'Doğrulama başarısız');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 text-center">
        {status === 'loading' && (
          <>
            <FiLoader className="mx-auto h-16 w-16 text-primary-600 animate-spin" />
            <h2 className="text-3xl font-serif font-light text-gray-900">
              E-posta Doğrulanıyor...
            </h2>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="mx-auto h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
              <FiCheckCircle className="h-10 w-10 text-green-600" />
            </div>
            <h2 className="text-3xl font-serif font-light text-gray-900">
              E-posta Doğrulandı!
            </h2>
            <p className="text-gray-600">{message}</p>
            <Link to="/login" className="btn-primary inline-block">
              Giriş Yap
            </Link>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mx-auto h-16 w-16 bg-red-100 rounded-full flex items-center justify-center">
              <FiXCircle className="h-10 w-10 text-red-600" />
            </div>
            <h2 className="text-3xl font-serif font-light text-gray-900">
              Doğrulama Başarısız
            </h2>
            <p className="text-gray-600">{message}</p>
            <Link to="/login" className="btn-secondary inline-block">
              Giriş Sayfasına Dön
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;

